<div class="burgerMenu" :class="{'open': sideMenu.isOpen}" @click="sideMenu.toggle"><span v-for="i in 9" :key="i"></span></div>